import { AdminPermissions } from '@admin/app/config/permission.config'
import { ADMIN_ROUTES } from '@admin/app/services/admin-navigation.service'
import { Component, OnInit } from '@angular/core'
import { PermissionStore } from '@engineering11/access-web'
import { PlatformAdminNavigationService, PlatformAdminRouteData } from '@engineering11/platform-admin-web'
import { INavBottomTab, INavigationItem } from '@engineering11/ui-lib/e11-nav-left'
import { map } from 'rxjs'

@Component({
  selector: 'layout-one',
  templateUrl: 'layout-one.component.html',
})
export class LayoutOneComponent implements OnInit {
  navigationList: INavigationItem[] = [
    {
      id: 'home',
      name: 'Home',
      route: ADMIN_ROUTES.HOME,
      icon: 'home',
      position: 'main',
    },
    {
      id: 'account',
      name: 'Account',
      route: ADMIN_ROUTES.ACCOUNT,
      icon: 'lock',
      position: 'main',
    },
    {
      id: 'reporting',
      name: 'Reporting',
      icon: 'insights',
      position: 'main',
      isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
      isOpen: (url: string) => (url ?? '').includes('reporting'),
      children: [
        {
          id: 'reporting-overview',
          name: 'Overview',
          route: ADMIN_ROUTES.REPORTING,
          isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
        },
        {
          id: 'reporting-users',
          name: 'Users',
          isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
          isOpen: (url: string) => (url ?? '').includes('reporting/users'),
          children: [
            {
              id: 'reporting-users-network',
              name: 'Network users',
              route: ADMIN_ROUTES.REPORTING_USERS_NETWORK,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-users-employer',
              name: 'Employer users',
              route: ADMIN_ROUTES.REPORTING_USERS_EMPLOYER,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
          ],
        },
        {
          id: 'reporting-recruiting',
          name: 'Recruiting',
          isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
          isOpen: (url: string) => (url ?? '').includes('reporting/recruiting'),
          children: [
            {
              id: 'reporting-recruiting-overview',
              name: 'Overview',
              route: ADMIN_ROUTES.REPORTING_RECRUITING,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-recruiting-job-posts',
              name: 'Job posts',
              route: ADMIN_ROUTES.REPORTING_RECRUITING_JOB_POSTS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-recruiting-applications',
              name: 'Applications',
              route: ADMIN_ROUTES.REPORTING_RECRUITING_APPLICATIONS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-recruiting-engagement',
              name: 'Candidate engagement',
              route: ADMIN_ROUTES.REPORTING_RECRUITING_ENGAGEMENT,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-recruiting-compliance',
              name: 'Compliance',
              route: ADMIN_ROUTES.REPORTING_RECRUITING_COMPLIANCE,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-recruiting-careers',
              name: 'Careers page',
              route: ADMIN_ROUTES.REPORTING_RECRUITING_CAREERS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
          ],
        },
        {
          id: 'reporting-tenants',
          name: 'Tenants',
          isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
          isOpen: (url: string) => (url ?? '').includes('reporting/tenants'),
          children: [
            {
              id: 'reporting-tenants-leaderboard',
              name: 'Tenant leaderboard',
              route: ADMIN_ROUTES.REPORTING_TENANTS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-tenants-clients',
              name: 'Customer clients',
              route: ADMIN_ROUTES.REPORTING_TENANTS_CLIENTS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
          ],
        },
        {
          id: 'reporting-activity',
          name: 'Activity',
          isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
          isOpen: (url: string) => (url ?? '').includes('reporting/activity'),
          children: [
            {
              id: 'reporting-activity-interactions',
              name: 'Interactions & funnel',
              route: ADMIN_ROUTES.REPORTING_ACTIVITY_INTERACTIONS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
          ],
        },
        {
          id: 'reporting-lifecycle',
          name: 'Lifecycle',
          isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
          isOpen: (url: string) => (url ?? '').includes('reporting/lifecycle'),
          children: [
            {
              id: 'reporting-lifecycle-signups',
              name: 'Signups & freemium',
              route: ADMIN_ROUTES.REPORTING_LIFECYCLE_SIGNUPS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-lifecycle-trials',
              name: 'Trials',
              route: ADMIN_ROUTES.REPORTING_LIFECYCLE_TRIALS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-lifecycle-conversions',
              name: 'Conversions',
              route: ADMIN_ROUTES.REPORTING_LIFECYCLE_CONVERSIONS,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
            {
              id: 'reporting-lifecycle-dormant',
              name: 'Dormant / at-risk',
              route: ADMIN_ROUTES.REPORTING_LIFECYCLE_DORMANT,
              isVisible: this.permissionStore.hasPermission(AdminPermissions.QueryReportingPlatformAdmin),
            },
          ],
        },
      ],
    },
    {
      id: 'crm',
      name: 'CRM',
      icon: 'contacts',
      position: 'main',
      isVisible: this.permissionStore.hasPermission(AdminPermissions.CrmView),
      isOpen: (url: string) => (url ?? '').includes('crm'),
      children: [
        {
          id: 'crm-dashboard',
          name: 'Dashboard',
          route: ADMIN_ROUTES.CRM,
          isVisible: this.permissionStore.hasPermission(AdminPermissions.CrmView),
        },
        {
          id: 'crm-work',
          name: 'My Work',
          route: ADMIN_ROUTES.CRM_TASKS,
          isVisible: this.permissionStore.hasPermission(AdminPermissions.CrmView),
        },
        {
          id: 'crm-accounts',
          name: 'Accounts',
          route: ADMIN_ROUTES.CRM_ACCOUNTS,
          isVisible: this.permissionStore.hasPermission(AdminPermissions.CrmView),
        },
        {
          id: 'crm-deals',
          name: 'Deals',
          route: ADMIN_ROUTES.CRM_DEALS,
          isVisible: this.permissionStore.hasPermission(AdminPermissions.CrmView),
        },
        {
          id: 'crm-pipeline',
          name: 'Pipeline',
          route: ADMIN_ROUTES.CRM_PIPELINE,
          isVisible: this.permissionStore.hasPermission(AdminPermissions.CrmView),
        },
        {
          id: 'crm-search',
          name: 'Customer Search',
          route: ADMIN_ROUTES.CRM_SEARCH,
          isVisible: this.permissionStore.hasPermission(AdminPermissions.CrmView),
        },
      ],
    },
    ...this.platformAdminNavigationService.menuItemActions,
    {
      id: 'testing',
      name: 'Testing',
      route: ADMIN_ROUTES.TESTING,
      icon: 'science',
      position: 'main',
      isVisible: this.permissionStore.hasPermission(AdminPermissions.UnresponsiveCheck),
    },
    {
      id: 'info_tips',
      name: 'Info and Tips',
      icon: 'tips_and_updates',
      position: 'footer',
    },
  ]

  mobileTabs: INavBottomTab[] = [
    {
      id: 'home',
      name: 'Home',
      routeGroup: 'main',
      icon: 'home',
    },
  ]
  mobileDrawerState = false
  constructor(private platformAdminNavigationService: PlatformAdminNavigationService, private permissionStore: PermissionStore) {}

  ngOnInit() {}
}
